<template>
  
</template>

<script>

export default {
    name: 'Home',
    components: { },
    data: function () {
        return {
            
        }
    },
    methods: {
    },
    mounted: function () {
       
    }
}
</script>